import React from 'react'

const LocationPageLoader = () => {
    const placeholders = Array.from({length: 8}, (_, index) => index)
    return (
        <div className="container mb-5 front-location-loader">
            <div className="front-location-loader__text">
                Even geduld alstublieft, wij zoeken de beste opties voor u.
            </div>
            <div className="row">
                {placeholders.map((item) => (
                    <div className="col-lg-3 col-md-6 col-sm-6 mt-5" key={item}>
                        <div className="front-vehicle-skeleton">
                            <div className="front-vehicle-skeleton__image" />
                            <div className="front-vehicle-skeleton__line front-vehicle-skeleton__line--title" />
                            <div className="front-vehicle-skeleton__line front-vehicle-skeleton__line--subtitle" />
                            <div className="front-vehicle-skeleton__badges">
                                <span />
                                <span />
                                <span />
                            </div>
                            <div className="front-vehicle-skeleton__prices">
                                <span />
                                <span />
                                <span />
                            </div>
                            <div className="front-vehicle-skeleton__button" />
                        </div>
                    </div>
                ))}
            </div>
        </div>
    )
}

export default LocationPageLoader
